import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import RiskForm from '../../components/Risks/RiskForm';
import riskService from '../../services/riskService';
import './RiskEdit.css';

const RiskEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [risk, setRisk] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRisk();
  }, [id]);

  const loadRisk = async () => {
    try {
      setLoading(true);
      const data = await riskService.getById(id);
      setRisk(data.data);
    } catch (error) {
      console.error('Error loading risk:', error);
      alert('Failed to load risk');
      navigate('/app/risks');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(`/app/risks/${id}`);
  };

  if (loading) {
    return (
      <div className="risk-edit-page">
        <div className="risk-edit-loading">Loading risk...</div>
      </div>
    );
  }

  return (
    <div className="risk-edit-page">
      <div className="risk-edit-header">
        <button onClick={handleBack} className="btn-back">
          <FiArrowLeft />
          Back to Risk Details
        </button>
      </div>
      <div className="risk-edit-content">
        <RiskForm risk={risk} />
      </div>
    </div>
  );
};

export default RiskEdit;

